import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { fetchAccounts } from 'features/accounts/reducers/recordsSlice';

import { accountsSelector } from 'features/accounts/selectors';

const AccountsContext = createContext(null);

export const AccountsContextProvider = ({ children }) => {
    const dispatch = useDispatch();

    const accounts = useSelector((state) => accountsSelector(state));

    useEffect(() => {
        dispatch(fetchAccounts());
    }, [dispatch]);

    return (
        <AccountsContext.Provider value={{ accounts }}>
            {children}
        </AccountsContext.Provider>
    );
};

AccountsContextProvider.propTypes = {
    children: PropTypes.object,
};
